import React from "react";
import { useSelector } from "react-redux";
import FavoriteComment from "./FavoriteComment";

const Favorites = ({ view, setActiveTab, setScrollableComment }) => {
  const { favorites } = useSelector((state) => state.favoriteReducer);

  return (
    <div className="px-5 py-5 max-w-600px mx-auto w-100 flex-1">
      <div className="h-100 overflow-auto">
        {favorites?.map((favorite) => (
          <FavoriteComment
            view={view}
            message={favorite}
            isOwner={false}
            setActiveTab={setActiveTab}
            setScrollableComment={setScrollableComment}
          />
        ))}
      </div>
    </div>
  );
};

export default Favorites;
